import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "logotype" }
const _hoisted_2 = { class: "flex center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "underline"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", { src: $setup.VideoLogo }, null, 8, _hoisted_3),
      _cache[0] || (_cache[0] = _createElementVNode("span", null, "Developing Tank", -1))
    ]),
    ($props.showBottom)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[1] || (_cache[1] = [
          _createElementVNode("hr", { class: "green cozy thick l-dotted" }, null, -1),
          _createElementVNode("hr", { class: "red cozy thick l-dotted" }, null, -1),
          _createElementVNode("hr", { class: "blue cozy thick l-dotted" }, null, -1),
          _createElementVNode("hr", { class: "yellow cozy thick l-dotted" }, null, -1)
        ])))
      : _createCommentVNode("", true)
  ]))
}